export default __webpack_public_path__ + "static/395-365270d5d1579a3f90789967b5c9f75b.gif";